module.exports = __webpack_public_path__ + "static/media/zy_swiper_c.b9b219cb.jpg";